/**
 * Converts a string to lower camel case, i.e., the first letter is lowercase, and subsequent words are capitalized.
 * @example  "firstName", "customerId", "isUserLoggedIn", "calculateTotalPrice"
 */
export const toLowerCamelCase = (value: string): string => {
  if (!value) return '';

  return value.charAt(0).toLowerCase() + value.slice(1);
};

export const initials = (value: string): string => {
  if (!value) return '';

  const res = value?.trim()?.split(' ');
  return res[0].charAt(0) + res[res.length - 1].charAt(0);
};

export const replaceSpacesWithUnderscores = (value: string): string => {
  if (!value) return '';

  return value.replace(/\s/g, '_');
};

export const firstNonBlank = (...values: (string | null | undefined)[]): string => {
  for (const value of values) {
    if (typeof value === 'string' && value.trim()) return value;
  }
  return '';
};
